import ProductCategorySpotlight from './product-category-spotlight.mobile';
import {HomepageFeaturedBlock, HighlightBrands} from '__generated__/__types__';
import {Product} from '@/_application/modules/products/model/product';

export interface HomepageFeaturedBlockWithProducts extends HomepageFeaturedBlock {
    fetchedProducts?: Product[];
    fetchedHighlightProduct?: Product | null;
}

export interface ProductCategorySpotlightListMobileProps {
    homepageFeaturedBlocks?: HomepageFeaturedBlockWithProducts[];
    highlightBrands?: HighlightBrands | null;
}

const ProductCategorySpotlightList = ({
    homepageFeaturedBlocks = [],
    highlightBrands,
}: ProductCategorySpotlightListMobileProps) => {
    if (homepageFeaturedBlocks.length === 0) {
        return null;
    }

    return (
        <div className="flex flex-col">
            {homepageFeaturedBlocks.map(block => (
                <ProductCategorySpotlight
                    key={block?.name}
                    data={block}
                    isDiaper={false}
                    highlightBrands={highlightBrands}
                />
            ))}
        </div>
    );
};

export default ProductCategorySpotlightList;
